import React, { useLayoutEffect } from "react";
import successIcon from "styleguide/icons/ds2/checkmarkcirclesolid.svg";
import errorIcon from "styleguide/icons/ds2/errorcirclesolid.svg";
import alertsolid from "styleguide/icons/ds2/alertsolid.svg";
import informationIcon from "../../../public/assets/images/informationIcon.svg";
import closeIcon from "styleguide/icons/ds2/close-outline.svg";
import "notifications-pattern/dist/main.css";
import notificationInit from "notifications-pattern/src/notification";
interface NotificationsProps {
  messageInfo?: string;
  variant?: "Informational" | "Success" | "Error" | "Alert";
  heading?: string;
  isClosable?: boolean;
  children?: React.ReactNode;
  widthClass?: string;
}

const Notifications: React.FC<NotificationsProps> = ({
  messageInfo,
  variant = "Informational",
  heading,
  isClosable = false,
  children,
  widthClass = "",
}) => {
  useLayoutEffect(() => {
    try {
      notificationInit();
    } catch (error) {
      console.error(" NotificationInit init error:", error);
    }
  }, []);

  const getIconName = () => {
    switch (variant) {
      case "Informational":
        return informationIcon;
      case "Alert":
        return alertsolid;
      case "Error":
        return errorIcon;
      default:
        return successIcon;
    }
  };
  return (
    <div className={`mt-8! lg:mt-0! ${widthClass}`}>
      <section
        aria-live="assertive"
        className={`ds-notification ${isClosable ? "ds-notification--dismiss" : ""}`}
        data-ds-version="1"
        data-ds-theme="vessel"
        data-ds-variant={variant}
        aria-labelledby="ds-notification__heading-0"
      >
        <div className="ds-notification__icon">
          <img src={getIconName()} alt={variant} width={40} height={40} />
        </div>
        {isClosable && (
          <button
            className="dismiss"
            data-dismiss="x-close"
            aria-label="Dismiss"
            data-analytics-type="button"
            data-analytics-click="Close Notification"
          >
            <img src={closeIcon} alt="" />
            <span>Close</span>
          </button>
        )}

        <div className="ds-notification__main-icon">
          {heading && (
            <div className="ds-notification__header">
              <div
                className="ds-notification__heading"
                id="ds-notification__heading-0"
              >
                {heading}
              </div>
            </div>
          )}
          <div className="ds-notification__body">
            <p dangerouslySetInnerHTML={{ __html: messageInfo || "" }}></p>
            {children}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Notifications;
